import React, { useState } from 'react'
import WarehouseList from './WarehouseList'
import WarehouseForm from './WarehouseForm';

const Warehouse= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <WarehouseForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <WarehouseList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default Warehouse